import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMusteriDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMusteriDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  Boss_VCustomerDetail: any[];
  Boss_VCustomerDetail_dummy: any[];
  Boss_VCustomerDetailTotal: any[];
  Boss_VCustomerDetailTotal_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class MusteriDetay_ScreenBase extends React.PureComponent<
  IMusteriDetay_ScreenProps,
  any
> {
  musteridetay_805667_value_kuikaSelectBoxRef: React.RefObject<any>;
  musteridetay_271925_value_kuikaTableRef: React.RefObject<any>;
  musteridetay_943659_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "5a01956c-80ba-4acb-90cc-4534f9510211",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 32897, PropertyName: "value", Value: "Müşteri Detay" },
        { Id: 98513, PropertyName: "value", Value: "Para Birimi" },
        { Id: 190919, PropertyName: "value", Value: "Net Varlık" },
        { Id: 805667, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        {
          Id: 271925,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 535927, PropertyName: "title", Value: "Title" },
        { Id: 436709, PropertyName: "value", Value: "[datafield:gun]" },
        { Id: 292787, PropertyName: "value", Value: "[datafield:ay]" },
        { Id: 184037, PropertyName: "value", Value: "[datafield:belgeno]" },
        { Id: 51600, PropertyName: "value", Value: "[datafield:belgetipi]" },
        { Id: 522841, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 557518, PropertyName: "value", Value: "[datafield:aciklama]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.musteridetay_805667_value_kuikaSelectBoxRef = React.createRef();
    this.musteridetay_271925_value_kuikaTableRef = React.createRef();
    this.musteridetay_943659_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      Boss_VCustomerDetail: [],
      Boss_VCustomerDetailTotal: [],
      SetValueOf: "",
      dataSource_805667: [
        { key: "1", text: "Bugün" },
        { text: "Son 7 Gün", key: "2" },
        { text: "Son 1 Ay", key: "3" },
        { text: "Son 3 Ay", key: "4" },
        { text: "Son 6 Ay", key: "5" },
        { text: "Son 1 Yıl", key: "6" },
        { text: "Tüm Tarihler", key: "7" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("musteridetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MusteriDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("musteridetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("musteridetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MusteriDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MusteriDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriDetay/MusteriDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    stateVars.Boss_VCustomerDetailTotal =
      result?.data.boss_VCustomerDetailTotal;
    formVars.musteridetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );
    formVars.musteridetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].tutar
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.musteridetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );

    formVars.musteridetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].tutar
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].tutar
        : null
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;
    formVars.musteridetay_943659_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.musteridetay_943659_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    formVars.musteridetay_943659_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.musteridetay_943659_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MusteriDetayComponent_544809_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriDetayComponent_805667_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "musteridetay_805667_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "musteridetay_805667_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriDetay/MusteriDetayComponent_805667_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    stateVars.Boss_VCustomerDetailTotal =
      result?.data.boss_VCustomerDetailTotal;
    formVars.musteridetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );
    formVars.musteridetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].tutar
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriDetayComponent_805667_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriDetayComponent_805667_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "musteridetay_943659_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.musteridetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].currencyCode
        : null
    );

    formVars.musteridetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCustomerDetailTotal !== undefined
        ? stateVars.Boss_VCustomerDetailTotal?.length > 0
          ? stateVars.Boss_VCustomerDetailTotal[0].tutar
          : null
        : this.state.Boss_VCustomerDetailTotal?.length > 0
        ? this.state.Boss_VCustomerDetailTotal[0].tutar
        : null
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MusteriDetayComponent_943659_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "musteridetay_805667_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "musteridetay_943659_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MusteriDetay/MusteriDetayComponent_943659_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCustomerDetail = result?.data.boss_VCustomerDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MusteriDetayComponent_943659_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MusteriDetayComponent_943659_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_271925 =
      stateVars.Boss_VCustomerDetail ?? this.state.Boss_VCustomerDetail;
    formVars.musteridetay_943659_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.musteridetay_943659_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    formVars.musteridetay_943659_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].totalCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].totalCount
        : null
    );
    formVars.musteridetay_943659_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCustomerDetail !== undefined
        ? stateVars.Boss_VCustomerDetail?.length > 0
          ? stateVars.Boss_VCustomerDetail[0].pageCount
          : null
        : this.state.Boss_VCustomerDetail?.length > 0
        ? this.state.Boss_VCustomerDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MusteriDetayPageInit();
    }
  }
}
